import * as React from "react";
import { useState, useEffect } from "react";
import { Nav, INavLinkGroup, INavLink } from 'office-ui-fabric-react/lib/Nav'
import { NavigationResponse, NavigationNode } from "../common/model/NavNode";
import constants from "../common/constants";
import { getLinks, GetSelected } from "./helper";


export function SideBarNav(props: NavigationResponse) {
    const [, reRender] = useState(0);
    useEffect(() => {
        window.onresize = () => {
            reRender(new Date().getTime());
        };
    }, []);
    if (window.innerWidth <= constants.responsiveWidthThreshold) {
        return null;
    }
    let linkGroup: INavLinkGroup[] =
        [{
            links: props.QuickLaunchNodes.map((n) => getLinks(n))
        }];
    var selectedKey = GetSelected(props.QuickLaunchNodes);
    return (
        <div>
            <div className="sideNavSpacer"></div>
            <Nav
                styles={{
                    root: {
                        boxSizing: 'border-box',
                        overflowX: 'hidden',
                        background: "none"
                    }
                }}
                selectedKey={selectedKey}
                className="kofiNav mobileSideNav"
                groups={linkGroup}
                isOnTop={true}
            />
        </div>
    );
}

